<template>
  <router-view v-slot="{ Component, route }">
    <transition name="custom-fade" mode="out-in">
      <div :key="route.name">
        <component :is="Component"></component>
      </div>
    </transition>
  </router-view>
  <Toaster richColors  />
</template>


<style>

.custom-fade-enter-active .page-content,
.custom-fade-leave-active .page-content {
  transition: ease all;
}
.custom-fade-enter-from .page-content,
.custom-fade-leave-to .page-content {
  opacity: 0;
}



</style>
<script setup>
import { Toaster } from 'vue-sonner'


</script>


